import {
  AccordionDetails,
  AccordionSummary,
  Box,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import React, { ReactElement, useState } from "react";
import { packageTypes } from "../../../../const/types/editBookingTypes";
import { FieldErrors, useFieldArray, useFormContext } from "react-hook-form";
import { ReactHookFormSelect } from "../../../ReactHookFormSelect/ReactHookformSelect";

import Accordion from "@mui/material/Accordion";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

interface CustomsInformationProps {
  classes: {
    titlesBoxStyle: string;
    typography: string;
    textAndDropdownGrids: string;
    textField: string;
    formControl: string;
    inputLabelAndMenuItems: string;
  };
}

const CustomsInformation: React.FC<CustomsInformationProps> = ({
  classes,
}: CustomsInformationProps): ReactElement => {
  useState<string>("");

  const {
    register,
    control,
    formState: { errors },
  } = useFormContext();

  const { fields } = useFieldArray({
    control,
    name: "cargoUpdateRequestDtos",
  });

  if (fields.length === 0) return <></>;

  const cargoErrors = errors.cargoUpdateRequestDtos as
    | FieldErrors[]
    | undefined;

  const errorBorder = cargoErrors
    ? {
        border: "1px solid red",
        boxShadow: "0 0 1px red",
      }
    : {};

  return (
    <>
      <Box className={classes.titlesBoxStyle}>
        <Typography className={classes.typography} variant="h6">
          Customs Information
        </Typography>
      </Box>
      <Accordion
        style={{ marginBottom: "15px" }}
        sx={errorBorder}
        defaultExpanded
      >
        <AccordionSummary
          expandIcon={<ArrowDownwardIcon />}
          aria-controls="cargoContainer-content"
          id="cargoContainer-header"
        >
          <Typography>Cargo</Typography>
        </AccordionSummary>
        <AccordionDetails>
          {fields.map((item, index) => {
            return (
              <Accordion
                key={item.id}
                sx={cargoErrors?.[index] ? errorBorder : {}}
                defaultExpanded={cargoErrors?.[index] ? true : false}
              >
                <AccordionSummary
                  expandIcon={<ArrowDropDownIcon />}
                  aria-controls={"cargo" + index + "-content"}
                  id={"cargo" + index + "-header"}
                >
                  <Typography>{"Cargo " + (index + 1)}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid
                    container
                    spacing={2}
                    className={classes.textAndDropdownGrids}
                  >
                    <Grid item xs={3}>
                      <TextField
                        className={classes.textField}
                        id={`cargoUpdateRequestDtos.${index}.numberOfPackages`}
                        type="number"
                        InputProps={{
                          inputProps: { min: 0 },
                        }}
                        label="Number of Packages"
                        {...register(
                          `cargoUpdateRequestDtos.${index}.numberOfPackages`,
                          {
                            valueAsNumber: true,
                          }
                        )}
                        error={Boolean(cargoErrors?.[index]?.numberOfPackages)}
                        helperText={
                          cargoErrors?.[
                            index
                          ]?.numberOfPackages?.message?.toString() || ""
                        }
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <TextField
                        className={classes.textField}
                        id={`cargoUpdateRequestDtos.${index}.goodsDescription`}
                        type="text"
                        label="Goods Description"
                        {...register(
                          `cargoUpdateRequestDtos.${index}.goodsDescription`
                        )}
                        error={Boolean(cargoErrors?.[index]?.goodsDescription)}
                        helperText={
                          cargoErrors?.[
                            index
                          ]?.goodsDescription?.message?.toString() || ""
                        }
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <ReactHookFormSelect
                        labelId="packageType-labelId"
                        selectId="packageType-id"
                        name={`cargoUpdateRequestDtos.${index}.packageType`}
                        control={control}
                        label="Package Type"
                        options={packageTypes}
                        classes={classes}
                        error={Boolean(cargoErrors?.[index]?.packageType)}
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <TextField
                        className={classes.textField}
                        id={`cargoUpdateRequestDtos.${index}.netWeight`}
                        type="number"
                        InputProps={{
                          inputProps: { min: 0 },
                        }}
                        label="Net Weight"
                        {...register(
                          `cargoUpdateRequestDtos.${index}.netWeight`,
                          {
                            valueAsNumber: true,
                          }
                        )}
                        error={Boolean(cargoErrors?.[index]?.netWeight)}
                        helperText={
                          cargoErrors?.[
                            index
                          ]?.netWeight?.message?.toString() || ""
                        }
                      />
                    </Grid>

                    <Grid item xs={3}>
                      <TextField
                        className={classes.textField}
                        id={`cargoUpdateRequestDtos.${index}.exportMRNNumber`}
                        type="text"
                        label="Export MRN Number"
                        {...register(
                          `cargoUpdateRequestDtos.${index}.exportMRNNumber`
                        )}
                        error={Boolean(cargoErrors?.[index]?.exportMRNNumber)}
                        helperText={
                          cargoErrors?.[
                            index
                          ]?.exportMRNNumber?.message?.toString() || ""
                        }
                      />
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>
            );
          })}
        </AccordionDetails>
      </Accordion>
    </>
  );
};

export default CustomsInformation;
